export { favorsDisfavor, favorsFavorite } from '@/app/services/tools';
